import request from '@/utils/request'

let Risk_typeApi = {

  /*风险事故类型列表*/
  list(data) {
    return request._post('/shop/plus.risk_type.Index/index', data);
},
/*添加风险事故类型*/
add(data) {
    return request._post('/shop/plus.risk_type.Index/add', data);
},
/*修改风险事故类型*/
edit(data) {
    return request._post('/shop/plus.risk_type.Index/edit', data);
},
/*删除风险事故类型*/
del(data) {
    return request._post('/shop/plus.risk_type.Index/del', data);
},
/*风险事故类型详情*/
detail(data) {
  return request._post('/shop/plus.risk_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.risk_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.risk_type.Setting/getSetting', data, errorback);
    },
}
export default Risk_typeApi;



// WEBPACK FOOTER //
// ./src/api/risk_type.js